import * as React from "react";
import { useState } from 'react';
import 'components/account/Account.pcss';
import {AccountOverview} from "components/account/AccountOverview";
import {AccountDataPrivacy} from "components/account/AccountDataPrivacy";
import {AccountDeleteConfirm} from "components/account/AccountDeleteConfirm";
import {AccountProfile} from "components/account/AccountProfile";
import {AccountParticipationSettings} from "components/account/AccountParticipationSettings";
import {AccountRemoveParticipationConfirm} from "components/account/AccountRemoveParticipationConfirm";
import {DashboardSolution} from "data/entities/DashboardSolution";

export interface IAccountPage {
  id: number;
}
export const AccountPages:{[id:string]:IAccountPage} = {
  Overview:{id:0},

  Profile:{id:1},
  AccountParticipation:{id:2},
  DataPrivacy:{id:3},

  AccountDeleteConfirmation:{id:9},
  RemoveParticipationConfirmation:{id:10},
}



export function Account() {

  const [accountPage, setAccountPage] = useState(AccountPages.Overview);
  const [dashboardSolution, setDashboardSolution] = useState<DashboardSolution|null>(null);

  function handleRemoveDashboardSolution(_dashboardSolution:DashboardSolution) {
    setDashboardSolution(_dashboardSolution);
    setAccountPage(AccountPages.RemoveParticipationConfirmation);
  }

  switch (accountPage) {
    case AccountPages.Overview:
      document.title = "Account Overview";
      return <AccountOverview onChangeAccountPage={setAccountPage} />;
    case AccountPages.Profile:
      document.title = "Your Profile";
      return <AccountProfile onChangeAccountPage={setAccountPage} />;
    case AccountPages.AccountParticipation:
      document.title = "Participation Settings";
      return <AccountParticipationSettings onChangeAccountPage={setAccountPage} onRemoveDashboardSolution={handleRemoveDashboardSolution} />;
    case AccountPages.DataPrivacy:
      document.title = "Data & Privacy";
      return <AccountDataPrivacy onChangeAccountPage={setAccountPage} />;
    case AccountPages.AccountDeleteConfirmation:
      document.title = "Account Deletion Confirmation";
      return <AccountDeleteConfirm onChangeAccountPage={setAccountPage} />;
    case AccountPages.RemoveParticipationConfirmation:
      if(dashboardSolution) {
        document.title = "Confirm remove participation in " + dashboardSolution.name + "";
        return <AccountRemoveParticipationConfirm onChangeAccountPage={setAccountPage} dashboardSolution={dashboardSolution}/>;
      } else {
        document.title = "Confirm remove participation";
        return <AccountOverview onChangeAccountPage={setAccountPage} />;
      }
    default:
      document.title = "Account Overview";
      return <AccountOverview onChangeAccountPage={setAccountPage} />;
  }

}
